import { useQueryClient } from "@tanstack/react-query";
import {
  PAPER_UPLOADING_FILE_KEY,
  UploadingFileInfo,
} from "./useResearchPaperUpload";

/**
 * Hook to get all currently uploading files from react-query cache.
 * Returns an array of file info objects for all files currently being uploaded.
 */
export const useAllUploadingFiles = (): UploadingFileInfo[] => {
  const queryClient = useQueryClient();

  // Get all queries that match the pattern [PAPER_UPLOADING_FILE_KEY, ...]
  const allUploadingQueries = queryClient.getQueriesData({
    queryKey: [PAPER_UPLOADING_FILE_KEY],
    exact: false, // This allows partial matches
  });

  // Extract the file info from each query
  return allUploadingQueries
    .map(([, data]) => data as UploadingFileInfo)
    .filter(Boolean);
};

export default useAllUploadingFiles;
